export const showSize = (size: number) => {
    if (size >= 1000000) return Math.round(size / 100000) / 10 + ' MB';
    if (size >= 1000) return Math.round(size / 100) / 10 + ' KB';
    if (size < 1000) return size + ' B';
};
